import { fetchQuoteCollaboratorsList } from '@views/screens/Quote/data-provider/quote-collaborators-list';
import { useQuery } from '@tanstack/react-query';

export const useGetQuoteCollaboratorsList = (spotQuoteId: string, options?: { enabled?: boolean }) => {
  return useQuery({
    enabled: (options?.enabled ?? true) && Boolean(spotQuoteId),
    queryFn: () => fetchQuoteCollaboratorsList(spotQuoteId),
    queryKey: ['quote-collaborators-list', spotQuoteId],
  });
};
